<template>
    <div class="main-sub-wrapper">
        <div class="radnja-tbr-main-wrapper" @click="showChildren = !showChildren">
            <div :class="['main-tbr',showChildren ? 'active' : '']">
                <div class="number-name-wrapper">
                    <div class="tbr-name-wrapp" >
                        <div :class="['tbr-name', is_latest ? 'active' : '']">
                            <span>Verzija {{note.version}} </span>
                            <div class="edit-delete-wrapper">
                                <div @click.stop="editReleaseNote" class="edit-case-name add-button add-pen"><svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13"><g><g><path fill="#7b7b8a" d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"></path></g></g></svg></div>
                                <div @click.stop="deleteReleaseNote" class="edit-case-name add-button add-pen"><svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.29826 2.40299C9.47656 2.40299 9.625 2.55103 9.625 2.7394V2.91356C9.625 3.09735 9.47656 3.24998 9.29826 3.24998H1.70218C1.52344 3.24998 1.375 3.09735 1.375 2.91356V2.7394C1.375 2.55103 1.52344 2.40299 1.70218 2.40299H3.03855C3.31001 2.40299 3.54626 2.21003 3.60733 1.93778L3.67732 1.6252C3.78608 1.19941 4.14402 0.916626 4.55367 0.916626H6.44633C6.85152 0.916626 7.21348 1.19941 7.31823 1.60274L7.39311 1.93732C7.45374 2.21003 7.68999 2.40299 7.96189 2.40299H9.29826ZM8.61934 8.76972C8.75886 7.46944 9.00313 4.38031 9.00313 4.34914C9.01205 4.25473 8.98129 4.16535 8.92022 4.09339C8.85469 4.02602 8.77178 3.98615 8.6804 3.98615H2.32307C2.23125 3.98615 2.14388 4.02602 2.08326 4.09339C2.02174 4.16535 1.99143 4.25473 1.99589 4.34914C1.99671 4.35487 2.00547 4.46368 2.02013 4.6456C2.08523 5.45376 2.26654 7.70462 2.38369 8.76972C2.4666 9.55438 2.98145 10.0475 3.7272 10.0654C4.30266 10.0787 4.89551 10.0833 5.50174 10.0833C6.07275 10.0833 6.65267 10.0787 7.24597 10.0654C8.01757 10.0521 8.53197 9.56767 8.61934 8.76972Z" fill="#70707E"></path></svg></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tbr-more-svg"><svg xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:avocode="https://avocode.com/" id="SVGDoc"
                        width="14" height="9" version="1.1" viewBox="0 0 14 9">
                        <defs />
                        <desc>Generated with Avocode.</desc>
                        <g>
                            <g>
                                <title>Vector</title>
                                <path d="M0.99946,0.99986v0l6.00028,6.00014v0l6.00016,-6.00014v0" fill-opacity="0"
                                    fill="#ffffff" stroke-dashoffset="0" stroke-dasharray="" stroke-linejoin="miter"
                                    stroke-linecap="butt" stroke-opacity="1" stroke="#3326ae" stroke-miterlimit="20"
                                    stroke-width="2.0000000000000018" />
                            </g>
                        </g>
                    </svg></div>
            </div>
        </div>
        <div v-show="showChildren" class="sub-tbr act">
            <div class="release-details" v-html="note.details">
            </div>
            <div class="release-date">Datum: {{getDate(note.release_date)}}</div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props:['note', 'is_latest'],
    data() {
        let show_child = false;
        if (this.is_latest) {
            show_child = true;
        }
        return {
            showChildren:show_child,
        }
    },
    methods: {
        getDate(date) {
          return moment(date).format("DD.MM.yyyy.");
        },
        editReleaseNote(){
            this.$emit('editNote')
        },
        deleteReleaseNote(){
            this.$emit('deleteNote')
        }
    },
}
</script>

<style>

</style>